import { Component, EventEmitter, Output } from '@angular/core';
@Component({
    selector: 'ca-query-builder-node-duplicate-button',
    templateUrl: './query-builder-node-duplicate-button.component.html',
    styleUrl: './query-builder-node-duplicate-button.component.scss',
    standalone: false
})
export class QueryBuilderNodeDuplicateButtonComponent {
  @Output()
  buttonClick: EventEmitter<MouseEvent> = new EventEmitter();

  onClickDuplicate(e: MouseEvent): void {
    this.buttonClick.emit(e);
  }
}
